import styled, { css } from 'styled-components';

import { COLORS } from 'helpers/enums/colors';

import { IButtonProps } from './types';

export const CustomButton = styled.button`
  padding: 8px 16px;
  color: ${COLORS.white};
  font-family: 'Montserrat', Helvetica, Arial, serif;
  font-size: 14px;
  font-weight: 500;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  outline: none;

  ${({ disabled }: IButtonProps) =>
    disabled
      ? css`
          background: ${COLORS.gray};
          border: 2px solid ${COLORS.gray};
          cursor: not-allowed;
        `
      : css`
          &.primary.contained {
            background: ${COLORS.blueRibbon};
            border: 2px solid ${COLORS.blueRibbon};

            :hover {
              background: ${COLORS.blueEndeavour};
              border: 2px solid ${COLORS.blueEndeavour};
            }
          }

          &.primary.outlined {
            color: ${COLORS.blueRibbon};
            background: ${COLORS.white};
            border: 2px solid ${COLORS.blueRibbon};

            :hover {
              background: ${COLORS.grayPorcelain};
            }
          }

          &.error.contained {
            background: ${COLORS.redMonza};
            border: 2px solid ${COLORS.redMonza};

            :hover {
              background: ${COLORS.redMilano};
              border: 2px solid ${COLORS.redMilano};
            }
          }

          &.error.outlined {
            color: ${COLORS.redMonza};
            background: ${COLORS.white};
            border: 2px solid ${COLORS.redMonza};

            :hover {
              background: ${COLORS.grayPorcelain};
            }
          }

          &.success.contained {
            background: ${COLORS.greenAtlantis};
            border: 2px solid ${COLORS.greenAtlantis};

            :hover {
              background: ${COLORS.greenLaPalma};
              border: 2px solid ${COLORS.greenLaPalma};
            }
          }

          &.success.outlined {
            color: ${COLORS.greenAtlantis};
            background: ${COLORS.white};
            border: 2px solid ${COLORS.greenAtlantis};

            :hover {
              background: ${COLORS.grayPorcelain};
            }
          }
        `}
`;
